import React, { FunctionComponent } from 'react';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconAttachmentType: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faPaperclip} />;

export { BrassIconAttachmentType };
